import * as actions from './navbarActions';

const navbarReducers = {
  [actions.NAVBAR_SEARCH_FORM_TOGGLE]: (state, { payload }) => {
    state.searchActive = payload === false ? payload : !state.searchActive;
    return state;
  },
  [actions.NAVBAR_TAKEOVER_CONTENT_SET]: (state, { payload }) => {
    state.takeover = payload;
    return state;
  },
  [actions.CLEAR_NAVBAR_TAKEOVER_CONTENT]: state => {
    delete state.takeover;
    return state;
  },
};

export default {
  name: 'navbar',
  reducers: navbarReducers,
};
